import { render, staticRenderFns } from "./samut-prakan-hub.vue?vue&type=template&id=35fc4994&scoped=true"
import script from "./samut-prakan-hub.vue?vue&type=script&lang=js"
export * from "./samut-prakan-hub.vue?vue&type=script&lang=js"
import style0 from "./samut-prakan-hub.vue?vue&type=style&index=0&id=35fc4994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc4994",
  null
  
)

export default component.exports